
import React from 'react';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import Text from '../../common/client/components/Text';

import LinkToOpsub from './LinkToOpsub';

const classNames = mergeStyleSets({
    list: {
        overflowY: 'auto',
        maxHeight: 250
    },
    opsubPodil: {
        paddingLeft: 4,
        paddingRight: 4
    }
});

const ObjectInfoOpsub = (props) => {
    return (
        <div>
            <Stack horizontal>
                <Stack.Item grow>
                    {(props.item.opsub_id)
                        ? <LinkToOpsub opsub={props.item} />
                        : <Text>{props.item.name}</Text>
                    }
                </Stack.Item>
            </Stack>
        </div>
    );
}

const ObjectInfoVlastnici = (props) => {
    return (
        <div className={classNames.list}>
            {props.opsub.map(item => {
                return (
                    <ObjectInfoOpsub key={item.opsub_id} item={item} />
                )
            })}
        </div>
    );
}

export default ObjectInfoVlastnici;
